module.exports = __webpack_public_path__ + "img/whyluckperms-3.77685de8.png";